import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController, NavController, Platform } from '@ionic/angular';
import { LoginPage } from '../login/login.page';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api/api.service';
import { UtilService } from 'src/app/services/util/util.service';
import { Store } from '@ngrx/store';
import { AuthenticationService } from 'src/app/services/auth/authentication.service';
import { CommonService } from 'src/app/services/common/common.service';
import { ConstantService } from 'src/app/services/constant/constant.service';
import { result } from 'lodash';
import { TermsOfServicePage } from '../terms-of-service/terms-of-service.page';
import { PrivacyPolicyPage } from '../privacy-policy/privacy-policy.page';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { AnalyticsEvents } from 'src/app/services/analytics/analytics.events';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.page.html',
  styleUrls: ['./signup.page.scss'],
})

export class SignupPage implements OnInit {
  myForm: UntypedFormGroup;
  submitted = false;
  passwordType: string = 'password';
  passwordIcon: string = 'eye-off';
  loading = false;
  alreadyExist = false;
  passwordNotCorrect = false;
  emailFocusValue = false;
  emailVerified = false;
  user: any;
  @Input() fromPage: string;
  alertpreFlag = false;
  user_id: any;
  nameFeild = false;
  emailFeild = false;
  companyFeild = false;
  flagCode = false;
  // §5.3a — email is already another user's connected secondary: guided-choice + verify-and-adopt state.
  secondaryContactChoice = false;
  adoptSecondary = false;
  newUserSub = '';
  verificationCodeForCount: any;
  verificationCode: any;
  currentUserSub: any;
  @Input() from: string;
  @Input() username: string;
  @Input() contactMethod: string;
  @Input() contactValue: string;
  @Input() decryptedData: any; // Accept the full decrypted object
  wrongCode = false;
  verificationSuccess = false
  hasNumber = false;
  has6Digit = false;
  decryptedDeeplinkData: any;
  resendDisabled = false;
  countdown = 30;
  timer: any;
  isMobile: boolean;
  isDesktop: boolean;

  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    inputStyles: {
      backgroundColor: 'var(--ion-color-white)',
      color: 'var(--ion-color-text)',
      border: '1px solid var(--ion-color-border)',
    }
  }

  @ViewChild('inputEmail', { static: false }) inputEmail;
  constructor(private navCtrl: NavController,
    private router: Router,
    private modalCtrl: ModalController,
    private formBuilder: UntypedFormBuilder,
    private common: CommonService,
    private constant: ConstantService,
    private api: ApiService,
    private util: UtilService,
    private authServices: AuthenticationService,
    private route: ActivatedRoute,
    private store: Store,
    private platform: Platform,
    private analytics: AnalyticsService
  ) { }

  ngOnInit() {

    let platform = this.platform.platforms();
    this.isMobile = platform.includes('mobile');
    this.isDesktop = platform.includes('desktop');

    // Get the entire decrypted object from localStorage
    const storedData = localStorage.getItem('deeplinkDecryptedData');
    if (storedData) {
      this.decryptedDeeplinkData = JSON.parse(storedData);
    }

    // Use componentProps if passed, otherwise use stored data
    if (this.decryptedData) {
      this.decryptedDeeplinkData = this.decryptedData;
    }

    const contactMethod = this.contactMethod || this.decryptedDeeplinkData?.method;
    const isMobile = contactMethod?.toLowerCase() === 'mobile';

    // Get prefilled contact value
    const prefEmail = (contactMethod?.toLowerCase() === 'email')
      ? (this.contactValue || this.decryptedDeeplinkData?.contactValue || localStorage.getItem('emailFromLogin'))
      : null;
    const prefMobile = (contactMethod?.toLowerCase() === 'mobile')
      ? (this.contactValue || this.decryptedDeeplinkData?.contactValue || localStorage.getItem('mobileFromLogin'))
      : null;
    this.myForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      company: [''],
      email: ['', [Validators.required, Validators.pattern('[A-Za-z0-9._%+-]{1,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.][a-zA-Z]{1,4}) *$')]],
      password: ['', [Validators.required, Validators.pattern('(?=.*[a-zA-Z])(?=.*[0-9]).{6,}')]],
      agreeTerms: [false, [Validators.requiredTrue]]
    })

    if (this.from == 'login') {
      if (prefEmail) {
        this.myForm.controls.email.setValue(prefEmail);
      } else if (this.username) {
        this.flagCode = true;
        this.myForm.controls.email.setValue(this.username);
        this.startCountdown();
      }
    }

    // Prefill mobile if available
    if (prefMobile && !prefEmail) {
      this.myForm.controls.email.setValue(prefMobile);
    }
  }

  ionViewWillEnter() {
    // this.api.setSplitPane(false);
    const draft = sessionStorage.getItem('signupFormDraft');
    if (draft) {
      this.myForm.patchValue(JSON.parse(draft));
      sessionStorage.removeItem('signupFormDraft');
    }
    if (localStorage.getItem("emailFromLogin") != null) {
      let email = localStorage.getItem("emailFromLogin");
      this.myForm.controls.email.setValue(email);
    } else if (localStorage.getItem("mobileFromLogin") != null) {
      let mobile = localStorage.getItem("mobileFromLogin");
      this.myForm.controls.email.setValue(mobile);
    }
    setTimeout(() => {
      console.log("avyu")
      this.inputEmail.setFocus();
    }, 1000)
  }

  fullnameFocus() {
    this.nameFeild = true;
  }

  fullnameBlur() {
    this.nameFeild = false;
  }

  async termsOfService() {
    // this.router.navigate(['/terms-of-service']);
    if (this.isDesktop) {
      sessionStorage.setItem('signupFormDraft', JSON.stringify(this.myForm.value));
      this.modalCtrl.dismiss();
      this.router.navigate(['/terms-of-service']);
      return;
    } else {
      const modal = await this.modalCtrl.create({
        component: TermsOfServicePage,
        cssClass: 'modal_legal',
        componentProps: {
          isModal: true
        }
      });
      await modal.present();
    }
  }

  async privacyPolicy() {
    // this.router.navigate(['/privacy-policy']);
    if (this.isDesktop) {
      sessionStorage.setItem('signupFormDraft', JSON.stringify(this.myForm.value));
      this.modalCtrl.dismiss();
      this.router.navigate(['/privacy-policy']);
      return;
    } else {
      const modal = await this.modalCtrl.create({
        component: PrivacyPolicyPage,
        cssClass: 'modal_legal',
        componentProps: {
          isModal: true
        }
      });
      await modal.present();
    }
  }

  emailFocus() {
    this.emailFocusValue = true;
    this.alreadyExist = false;
    this.passwordNotCorrect = false;
    this.emailVerified = false;
    this.emailFeild = true;
  }

  emailBlur() {
    this.emailFeild = false;
  }

  companyFocus() {
    this.companyFeild = true;
  }

  companyBlur(){
    this.companyFeild = false;
  }

  hideShowPassword() {
    this.passwordType = this.passwordType === 'text' ? 'password' : 'text';
    this.passwordIcon = this.passwordIcon === 'eye-off' ? 'eye' : 'eye-off';
  }

  checkForHideShow(passwordType){
    if(passwordType == 'text'){
      return "Hide"
    }else{
      return "Show"
    }
  }

  onOtpChange(value) {
    this.verificationCodeForCount = value;
    if (this.verificationCodeForCount.length == 6) {
      this.verificationCode = this.verificationCodeForCount;
    }
  }

  submit() {
    if (this.verificationCodeForCount.length == 6) {
      this.checkVerification()
    }
  }

  goBack() {
    this.clearResendTimer();
    localStorage.removeItem("emailFromLogin");
    localStorage.removeItem("mobileFromLogin");
    localStorage.removeItem("deeplinkDecryptedData");
    this.modalCtrl.dismiss();
  }

  nameChange(event) {
    this.myForm.controls.name.setValue(this.capitalizeName(event.detail.value));
  }

  capitalizeName(name) {
    return name.replace(/\b(\w)/g, s => s.toUpperCase());
  }

  async login() {
    this.modalCtrl.dismiss();
    const modal = await this.modalCtrl.create({
      component: LoginPage,
      cssClass: 'modal_login',
      backdropDismiss: false
    });
    return await modal.present();
  }

  get errorCtr() {
    return this.myForm.controls;
  }

  async onSubmit() {
    this.submitted = true;
    if (!this.myForm.valid) {
      console.log('All fields are required.')
      this.emailFocusValue = false;
      this.emailVerified = false;
      return false;
    } else {
      this.loading = true;
      const contactMethod = this.contactMethod || this.decryptedDeeplinkData?.method || 'email';
      let dataMobile = {
        type: contactMethod?.toLowerCase() === 'mobile' ? 'mobile' : 'email',
        value: this.myForm.controls.email.value
      }
      this.common.callApi(
        this.constant.CHECK_USER_REGISTERED_V2,
        dataMobile,
        'POST',
        '',
        false,
        false,
        false
      ).subscribe(async (results: any) => {
        console.log("checkDataMobile === ", results);
        if (results.message == "User Exist") {
          this.loading = false
          this.alreadyExist = true;
        }else if(results.message == "Secondary Contact Exist"){
          // §5.3a — already another user's secondary: don't create silently, offer the choice.
          this.loading = false;
          this.secondaryContactChoice = true;
        }else if(results.status == 206){
          this.loading = false
          // Create cognito user
          this.user_id = results.id;
          this.registerUser('true');
        }
      }, (err) => {
        // this.loading = false;
        console.log("error in checkDataMobile", err.error.message);
        if (err.error.message = "User Not Exist") {
          this.registerUser('false');
        }
      })
    }
  }

  // §5.3a — "Use a different email": go back to the form so they can enter their own email.
  useDifferentEmail() {
    this.secondaryContactChoice = false;
    this.adoptSecondary = false;
    this.submitted = false;
    this.myForm.controls.email.reset();
  }

  // §5.3a — "Verify and use this email": create the account (Cognito OTP verifies email control),
  // and flag it so the secondary is retired from its previous owner once verified.
  verifyAndAdoptEmail() {
    this.adoptSecondary = true;
    this.secondaryContactChoice = false;
    this.loading = true;
    this.registerUser('false');
  }

  // §5.3a — retire the adopted email from its previous owner(s): routing-only handover.
  private adoptSecondaryContact() {
    const method = (this.contactMethod || 'email').toLowerCase() === 'mobile' ? 'mobile' : 'email';
    const data = { newUserId: this.newUserSub, value: this.myForm.value.email, method };
    this.common.callApi(this.constant.ADOPT_SECONDARY, data, 'POST', '', false, false, true)
      .subscribe(() => { }, (err) => console.log('adopt-secondary failed (non-blocking)', err));
  }

  registerUser(isPartial) {
    this.alreadyExist = false;
    let data = {
      email: this.myForm.value.email,
      password: this.myForm.value.password
    }
    // Api call for signup
    // this.loading = true;
    this.common.callApi(
      this.constant.REGISTER_V2,
      data,
      'POST',
      '',
      false,
      false,
      false
    ).subscribe(async (results: any) => {
      console.log("Register === ", results);
      if (results?.user?.hasOwnProperty("userSub")) {
        this.newUserSub = results?.user?.userSub;   // §5.3a — new account id for the adopt call
        this.loading = false;
        this.verificationCode = undefined;
        this.flagCode = true;
        this.startCountdown();
        this.passwordNotCorrect = false;
        this.alreadyExist = false;

        if(isPartial == 'true'){
         this.updateUser(results?.user?.userSub);
         // The trial row is created by the API when the account is confirmed — at this point there
         // is no token yet, and that endpoint now needs one.
        }else{
          this.addUserToDatabase(results?.user?.userSub);
        }

      }

    }, (err) => {
      this.loading = false;
      console.log("error in checkDataMobile === ", err,err?.error?.error?.name);
      if(err?.error?.error?.name == 'UsernameExistsException'){
        // this.alreadyExist = true;
        
        // The email already exists in Cognito. This covers two cases:
        // 1. Unconfirmed user who abandoned OTP -> resend the code and reopen
        //    the verification screen so they are never trapped.
        // 2. Fully confirmed user -> resend fails, fall back to "Login instead".
        this.resumePendingVerification();
      }
    })

    // await this.authServices.signUp(data).then(async (signUpres: any) => {
    //   console.log(signUpres, "--------");

    //   if (signUpres != 'InvalidPasswordException' && signUpres != 'UsernameExistsException') {
    //     this.loading = false;
    //     this.verificationCode = undefined;
    //     this.flagCode = true;
    //     this.passwordNotCorrect = false;
    //     this.alreadyExist = false;

    //     this.currentUserSub = signUpres.userSub;
    //     this.addFullName(signUpres.userSub);
    //   } else if (signUpres == 'InvalidPasswordException') {
    //     this.loading = false;
    //     this.passwordNotCorrect = true;
    //   } else if (signUpres == 'UsernameExistsException') {
    //     this.loading = false;
    //     this.alreadyExist = true;
    //   }
    // })
  }

  // Handles the case where the email already exists in Cognito. If the account
  // is unconfirmed (user abandoned OTP), resending the code succeeds and we
  // reopen the verification screen. If the account is already confirmed, the
  // resend fails and we fall back to prompting the user to log in instead.
  resumePendingVerification() {
    this.loading = true;
    let param = {
      email: this.myForm.value.email
    }
    this.common.callApi(
      this.constant.VERIFY_CODE_RESEND_V2,
      param,
      'POST',
      '',
      false,
      false,
      false
    ).subscribe((results: any) => {
      this.loading = false;
      this.alreadyExist = false;
      this.passwordNotCorrect = false;
      this.verificationCode = undefined;
      this.verificationCodeForCount = undefined;
      this.flagCode = true;
      this.startCountdown();
      this.util.presentToast("You already started signing up. We've re-sent your verification code.");
    }, err => {
      this.loading = false;
      console.log('error in resumePendingVerification - ', err);
      // User is already confirmed (or cannot be re-verified) -> treat as existing account.
      this.alreadyExist = true;
    })
  }

  updateUser(userSub){
    let data = {
      sk: "user#meta",
      updateBody: {
        GSI1PK: "user",
        GSI1SK: userSub,
        fullname: this.myForm.value.name,
        type: "main",
        termsAcceptedAt: new Date().toISOString(),
        termsVersion: '2026-06-23'
      }
    }

    console.log(data, "data user Update")

    this.common.callApi(
      this.constant.USER_UPDATE_FILTER,
      data,
      'PUT',
      '',
      false,
      false,
      true
    ).subscribe(async (results: any) => {
      console.log('Updated User Details -> ', results);
      this.loading = false;
    }, err => {
      this.loading = false;
      console.log('error in Update User Details - ', err);
    })
  }

  addUserToDatabase(username) {
    let param = {
      id: username,
      sk: 'user#meta',
      fullname: this.myForm.value.name,
      email: this.myForm.value.email,
      company: this.myForm.value.company,
      termsAcceptedAt: new Date().toISOString(),
      termsVersion: '2026-06-23'
    }
    console.log(param, "parameter");
    this.common.callApi(
      this.constant.CREATE_USER_V2,
      param,
      'POST',
      '',
      false,
      false,
      false
    ).subscribe((results: any) => {
      console.log('Added User -> ', results);
      localStorage.removeItem("emailFromLogin");
      localStorage.removeItem("mobileFromLogin");
      localStorage.removeItem("deeplinkDecryptedData");
      // Trial row: created by the API on confirm, see above.
    }, err => {
      console.log('error in Ading User - ', err);
    })
  }


  // addFullName(userSub) {
  //   let param = {
  //     sub: userSub,
  //     fullname: this.myForm.value.name,
  //     email: this.myForm.value.email
  //   }

  //   console.log(param, "parameter");
  //   this.common.callApi(
  //     this.constant.ADD_FULLNAME,
  //     param,
  //     'POST',
  //     '',
  //     false,
  //     false,
  //     false
  //   ).subscribe((results: any) => {
  //     console.log('Added Fullname -> ', results);
  //     localStorage.removeItem("emailFromLogin");
  //   }, err => {
  //     console.log('error in Ading Fullname - ', err);
  //   })
  // }

  async checkVerification() {
    this.loading = true;
    let param = {
      email: this.myForm.value.email,
      verification: this.verificationCode
    }
    console.log(param, "parameter");
    this.common.callApi(
      this.constant.VERIFY_CODE_V2,
      param,
      'POST',
      '',
      false,
      false,
      false
    ).subscribe((results: any) => {
      console.log(results);
      this.wrongCode = false;
      this.loading = false;
      this.verificationSuccess = true;
      // Analytics: user_signed_up (Master Spec §5.1)
      const userId = this.newUserSub || this.currentUserSub;

      if (userId) {
        this.analytics.identify(userId, {
          user_id: userId,
          email: this.myForm.value.email,
        });

        this.analytics.trackEvent(AnalyticsEvents.USER_SIGNED_UP, {
          signup_source_type: (this.decryptedDeeplinkData || this.decryptedData) ? 'referral' : 'direct',
          subscription_tier: 'free',
          created_at: new Date().toISOString(),
        });
      }
      // §5.3a — account verified (Cognito OTP proved email control); now retire the secondary
      // from its previous owner so future punch routes here (notice + audit handled server-side).
      if (this.adoptSecondary) this.adoptSecondaryContact();
    }, err => {
      console.log(err);
      if (err?.error?.error?.name == "CodeMismatchException") {
        this.loading = false;
        this.verificationSuccess = false;
        this.wrongCode = true;
        this.config = {
          allowNumbersOnly: true,
          length: 6,
          isPasswordInput: false,
          disableAutoFocus: false,
          inputStyles: {
            border: "1px solid red",
            backgroundColor: 'var(--ion-color-white)',
            color: 'var(--ion-color-text)',
          }
        }
      } else if (err?.error?.error?.name == "ExpiredCodeException") {
        this.loading = false;
        this.verificationSuccess = false;
        this.wrongCode = true;
        this.config = {
          allowNumbersOnly: true,
          length: 6,
          isPasswordInput: false,
          disableAutoFocus: false,
          inputStyles: {
            border: "1px solid red",
            backgroundColor: 'var(--ion-color-white)',
            color: 'var(--ion-color-text)',
          }
        }
        this.util.presentToast("Your code has been expired.")
      }
    })

    // await this.authServices.verifyCode(this.myForm.value.email, this.verificationCode).then(async (codeREs: any) => {
    //   console.log(codeREs, "--------");
    //   if (codeREs != 'ExpiredCodeException') {
    //     if (codeREs != "CodeMismatchException") {
    //       this.wrongCode = false;
    //       this.loading = false;
    //       this.verificationSuccess = true;
    //     } else {
    //       this.loading = false;
    //       this.verificationSuccess = false;
    //       this.wrongCode = true;
    //       this.config = {
    //         allowNumbersOnly: true,
    //         length: 6,
    //         isPasswordInput: false,
    //         disableAutoFocus: false,
    //         inputStyles: {
    //           border: "1px solid red"
    //         }
    //       }
    //     }
    //   } else {
    //     this.loading = false;
    //     this.verificationSuccess = false;
    //     this.wrongCode = true;
    //     this.config = {
    //       allowNumbersOnly: true,
    //       length: 6,
    //       isPasswordInput: false,
    //       disableAutoFocus: false,
    //       inputStyles: {
    //         border: "1px solid red"
    //       }
    //     }
    //     this.util.presentToast("Your code has been expired.")
    //   }
    // });
  }

  startCountdown() {
    this.clearResendTimer();
    this.resendDisabled = true;
    this.countdown = 30;

    this.timer = setInterval(() => {
      this.countdown--;

      if (this.countdown <= 0) {
        this.clearResendTimer();
        this.resendDisabled = false;
        this.countdown = 0;
      }
    }, 1000);
  }

  clearResendTimer() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  async resendOtp() {
    if (this.resendDisabled) return;
    let param = {
      email: this.myForm.value.email
    }
    console.log(param, "parameter");
    this.common.callApi(
      this.constant.VERIFY_CODE_RESEND_V2,
      param,
      'POST',
      '',
      false,
      false,
      false
    ).subscribe((results: any) => {
      console.log(results);
      if (results) {
        this.util.presentToast("A new verification code has been sent to your email.")
        this.startCountdown();
      }
    }, err => {
      console.log('error in Resend Code - ', err);
    })

    // resendCode
    // VERIFY_CODE_RESEND_V2
    // await this.authServices.resendCode(this.myForm.value.email).then(async (codeREs: any) => {
    //   console.log(codeREs, "--------");
    //   if (codeREs)
    //     this.util.presentToast("A new verification code has been sent to your email.")
    // })
  }

}
